import { List, NeoModel, ValueObject } from "@singularsystems/neo-core";
import FileTypeConfigurationLookup from "./FileTypeConfigurationLookup";

@NeoModel
export default class Filespec extends ValueObject {

    public fileType: string = "";

    public enumFileExtension: string = "";

    public enumFileDelimiter: string = "";

    public description: string = "";

    public fileTypeConfigurationsList = new List(FileTypeConfigurationLookup);

    public isExpanded: boolean | null = null;

    public latestVersionOfFileSpecID: number = 0;
}